// extracted by mini-css-extract-plugin
module.exports = {"phsForm":"_1FnoLlp6fUh4Tf3WNSNq8E"};